import { BulkActionsBarOutlet, BulkActionsBarProvider } from '@calendly/ui/components/bulk-actions-bar';
import { PageHeaderContext, PageHeaderOutlet } from '@calendly/ui/components/page-header';
import classNames from 'classnames';
import { ReactNode } from 'react';
import { CenterPanelContent } from 'features/app_shell/CenterPanelContent';
import { CenterPanelLayoutProvider } from 'features/app_shell/centerPanelLayoutContext';
import { CenterPanelSizeProvider } from 'features/app_shell/centerPanelSizeContext';
import { StickyFooterContext, StickyFooterOutlet } from 'features/layout';
import { SeatRequestsBanner } from 'features/seat_requests';
const centerPanelContainerCss = "cxvsueq";
const topChromeCss = "t1qxz42o";
const bottomChromeCss = "b14yqndb";
interface CenterPanelProps {
  children: ReactNode;
  className?: string;
}

/**
 * Primary content column in the app shell body row.
 * Owns the page header, scrollable content region (`CenterPanelContent`), sticky footer, and bulk-actions bar.
 * Also provides layout context (`CenterPanelLayoutProvider`) so child routes can opt into wide mode.
 *
 * @param children - Page content rendered inside the scrollable region.
 * @param className - Additional class applied to the outer container (e.g. shared `bodyPanelCss` border-radius).
 */
export const CenterPanel = ({
  children,
  className
}: CenterPanelProps) => <CenterPanelLayoutProvider>
    <CenterPanelSizeProvider>
      {sizeRef => <PageHeaderContext>
          <BulkActionsBarProvider>
            <StickyFooterContext>
              <main ref={sizeRef} className={classNames(className, centerPanelContainerCss)} data-component="main" id="shell-content">
                <div className={topChromeCss} id="shell-content-header">
                  <SeatRequestsBanner />
                  <PageHeaderOutlet />
                </div>
                <CenterPanelContent>
                  {children}
                </CenterPanelContent>
                <div className={bottomChromeCss}>
                  <StickyFooterOutlet />
                  <BulkActionsBarOutlet />
                </div>
              </main>
            </StickyFooterContext>
          </BulkActionsBarProvider>
        </PageHeaderContext>}
    </CenterPanelSizeProvider>
  </CenterPanelLayoutProvider>;

require("./CenterPanel.wyw-in-js.css!=!../../../../node_modules/@wyw-in-js/webpack-loader/lib/outputCssLoader.js?cacheProvider=!./CenterPanel.tsx");